const Lightbox = () => {
    const images = document.querySelectorAll('.js-lightbox-image')
    if (images.length < 1) return
        ;
    [...images].forEach(image => {
        image.addEventListener('click', addLightbox)
    })
}

function addLightbox (e) {
    e.preventDefault()
    console.log('click')
    // get img src
    let url = e.target.closest('.js-lightbox-image')
    let src = url.getAttribute('href')

    // create lightbox elements
    let lightbox = document.createElement('div')
    let loader = document.createElement('div')
    let image = document.createElement('img')
    let cross = document.createElement('div')

    // set elements
    lightbox.setAttribute('id', 'js-lightbox')
    lightbox.setAttribute('class', 'c-lightbox')
    loader.setAttribute('class', 'c-lightbox__loader')
    image.setAttribute('class', 'c-lightbox__image')
    image.setAttribute('src', src)
    cross.setAttribute('class', 'c-lightbox__cross')

    // add to dom
    document.body.appendChild(lightbox)
    lightbox.appendChild(loader)
    lightbox.appendChild(image)
    lightbox.appendChild(cross)

    // on image load
    image.addEventListener('load', () => {
        image.classList.add('c-lightbox__image--loaded')
        loader.classList.add('c-lightbox__loader--loaded')
    })

    // remove if clicked again
    lightbox.addEventListener('click', removeLightbox)
}

function removeLightbox () {
    const lightbox = document.getElementById('js-lightbox')
    document.body.removeChild(lightbox)
}

export default Lightbox

// WEBPACK FOOTER //
// ./src/js/modules/Lightbox.js
